<template>
    <div :class="$attrs.class">
      <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
      <div class="relative">
        <font-awesome-icon icon="fa-calendar" class="cursor-pointer z-10 absolute top-1/2 transform -translate-y-1/2 left-3" @click="() => this.$refs.datetimeinput.openMenu()" />
        <input ref="input" v-mask="'##:##'" :id="id" v-bind="{ ...$attrs, class: null }" class="form-input pl-8" :class="{ error: error }" type="tel" :value="inputValue"  @change="changeDateTime" @keyup="keyup" autocomplete="off" />
      </div>
      <Datepicker 
        ref="datetimeinput" 
        menuClassName="dp-custom-date-time" 
        v-model="value" 
        modelType="HH:mm:ss" weekStart="0" autoApply :clearable="false" 
        :closeOnAutoApply="false" :format="format" timePicker :class="{ error: error }" locale="pt-BR" 
        @update:modelValue="$emit('update:modelValue', modelValue)">
        <template #dp-input="{ value, onInput, onEnter, onTab, onClear }">
        </template>
      </Datepicker>
      <div v-if="error" class="form-error">{{ error }}</div>
    </div>
  </template>
  
  <script>
  import { v4 as uuid } from 'uuid'
  import Datepicker from '@vuepic/vue-datepicker';
  import '@vuepic/vue-datepicker/dist/main.css';
  import ptBR from 'date-fns/locale/pt-BR';
  import parse from 'date-fns/parse';
  import format from 'date-fns/format';
  import {mask, TheMask} from 'vue-the-mask'
  
  export default {
    data() {
      return {
        value: null,
        inputValue: null,
      }
    },
    mounted() {
      if(this.modelValue) {
        this.value = this.modelValue;
        let dateTime = this.modelValue.split(' ');
        let date = dateTime[1];
        this.inputValue = date;
      }
    },
    watch: {
      value(valueNew, valueOld) {
        let modelValue = null;
        let modelInputValue = null;
        console.log(this.value)
        if(this.value) {
          modelValue = this.value;
          let modelInputValueAux = this.value.split(' ');
          modelInputValue = modelInputValueAux[0].split('-').reverse().join('/') + ' ' + modelInputValueAux[1];
        }
        this.inputValue = modelInputValue;
        this.$emit('update:modelValue', modelValue);
      },
    },
    components: {
      Datepicker,
      ptBR,
      format,
      parse,
      TheMask,
    },
    directives: {
      mask
    },
    inheritAttrs: false,
    props: {
      id: {
        type: String,
        default() {
          return `text-input-${uuid()}`
        },
      },
      type: {
        type: String,
        default: 'text',
      },
      error: String,
      label: String,
      modelValue: String,
    },
    emits: ['update:modelValue'],
    methods: {
      focus() {
        this.$refs.input.focus()
      },
      select() {
        this.$refs.input.select()
      },
      setSelectionRange(start, end) {
        this.$refs.input.setSelectionRange(start, end)
      },
      format: (date) => format(date, 'HH:mm'),
      keyup(input) {
        this.$refs.datetimeinput.closeMenu();
      },
      changeDateTime(input) {
      console.log(input.target.value)
        let datetime = input.target.value;
        let dataFormatar = new Date(new Date().getFullYear() + '-' + new Date().getMonth() + '-' + new Date().getDate() + ' ' + datetime + ':00');
        let dateFormatted = datetime;
        if(dateFormatted) {
          this.value = dateFormatted;
        } else {
          input.target.value = '';
          this.value = null;
        }
      },
    },
  }
  </script>
  <style>
  .dp-custom-date-time .dp__active_date {
    background-color: var(--color-primary);
  }
  </style>